import { CommandModel, FilterSettingsModel, IFilter, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { SfCommandButtonType, SfFilterTypes } from '../../models/syncfusion-data';

export class GridConstantsFactory {
  private static DEFAULT_PAGE_SIZE = 20;
  public static createStandardPageSettings(): PageSettingsModel {
    return { pageSize: this.DEFAULT_PAGE_SIZE, pageCount: 10, pageSizes: [5,10,20]};
  }

  public static createStandardDataStateSettings() {
    return { skip: 0, take: this.DEFAULT_PAGE_SIZE };
  }

  public static createStandardEditSettings() {
    return {
      allowEditing: true,
      allowAdding: true,
      allowDeleting: true,
      mode: 'Dialog',
      showDeleteConfirmDialog: true
    };
  }

  public static createStandardGridCommands(): CommandModel[] {
    return [
      {
        type: SfCommandButtonType.Edit,
        buttonOption:
        {
          cssClass: 'icon-btn',
          iconCss: 'icon-edit e-icons'
        }
      },
      {
        type: SfCommandButtonType.Delete,
        buttonOption:
        {
          cssClass: 'icon-btn',
          iconCss: 'icon-trash-can e-icons e-danger'
        }
      }];
  }

  public static createStandardToolBarButtons() {
    return ['Add'];
  }

  public static createStandardFilterSettings(): FilterSettingsModel {
    return {type: SfFilterTypes.Menu};
  }

  public static createStandardFilterSettingsWithLimitedFilters(): FilterSettingsModel {
    return {
      type: SfFilterTypes.Menu,
      operators: {
        stringOperator: [
          { value: 'startsWith', text: "Starts With" },
          { value: 'endsWith', text: 'Ends With' },
          { value: 'contains', text: 'Contains' },
          { value: 'equal', text: 'Equal' },
          { value: 'notEqual', text: 'Not Equal' },
          { value: 'empty', text: 'Empty' },
          { value: 'notempty', text: 'Not Empty' },
          { value: 'doesnotstartwith', text: 'Does Not Start With' },
          { value: 'doesnotendwith', text: 'Does Not End With' },
          { value: 'doesnotcontain', text: 'Does Not COntain' },
        ],
        numberOperator: [
          { value: 'equal', text: 'Equal' },
          { value: 'notEqual', text: 'Not Equal' },
          { value: 'greaterThan', text: 'Greater Than' },
          { value: 'greaterThanOrEqual', text: 'Greater Than Or Equal' },
          { value: 'lessThan', text: 'Less Than' },
          { value: 'lessThanOrEqual', text: 'Less Than Or Equal' }
        ],
        dateOperator: [
          { value: 'equal', text: 'Equal' },
          { value: 'notEqual', text: 'Not Equal' },
          { value: 'greaterThan', text: 'After' },
          { value: 'lessThan', text: 'Before' }
        ],
        booleanOperator: [
          { value: 'equal', text: 'Equal' },
          { value: 'notEqual', text: 'Not Equal' }
        ]
      }
    };
  }

  public static createCheckBoxFilter(): IFilter {
    return {type: SfFilterTypes.CheckBox};  // Beware! type is at the moment still string!
  }

  public static createDateFilter(): IFilter {
    return {
      params: {
        format: 'dd.MM.yyyy'
      }
    };
  }
}
